import GoldWatch from "./scenes/GoldWatch";
import Homeplace from "./scenes/Homeplace";
import Replaced from "./scenes/Replaced";
import TheCloud from "./scenes/TheCloud";
import MainStreet from "./scenes/MainStreet";
import TheWorkingMan from "./scenes/TheWorkingMan";

// Each act illustrates one section of the song. Boundaries are seconds into
// the YouTube track (4:36) and are estimates: open /?sync and tap M
// as each `cue` starts to measure the real ones, then paste them here.
export const SONG_LENGTH = 276;
export const FADE = 2.5;
export const CREDITS_AT = 268;

export const SCENES = [
  { id: "gold-watch", n: "I", title: "The Gold Watch", cue: "spoken intro", start: 0, end: 35, Component: GoldWatch },
  { id: "homeplace", n: "II", title: "The Homeplace", cue: "first verse", start: 35, end: 80, Component: Homeplace },
  { id: "replaced", n: "III", title: "Replaced", cue: "first chorus", start: 80, end: 118, Component: Replaced },
  { id: "the-cloud", n: "IV", title: "The Cloud", cue: "second verse", start: 118, end: 178, Component: TheCloud },
  { id: "main-street", n: "V", title: "Main Street", cue: "bridge", start: 178, end: 205, Component: MainStreet },
  { id: "the-working-man", n: "VI", title: "The Working Man", cue: "last chorus", start: 205, end: 276, Component: TheWorkingMan },
];
